import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { ArrowRightIconAtom } from '../../icon-atoms/icon-atoms';
import { GTM_ID } from '../../../../../common/constants/gtmIds';
import { Link, navigate } from 'gatsby';
import { NavbarSuperLinkProps } from './navbar-superlink.types';
import { shouldForwardProp } from '@utils/utils';
import { WrapperProps } from '../navbar-atoms-common.types';

const StyledLink = styled(Link, {
  shouldForwardProp: prop => shouldForwardProp(['hasBackground'], prop),
})<WrapperProps>(() => {
  return `
    display: flex;
    text-decoration: none;
    font-size: 1.4rem;
    padding: ${vars.spacingXs};
    margin-left: -${vars.spacingXs};
    align-items: center;
  
    &:hover .superlink::before {
      transform: scaleX(1);
    }
  `;
});

const IconWrapper = styled.span`
  display: flex;
  margin: 0 ${vars.spacingXs} 0 0;
`;

const Title = styled.p`
  font-weight: ${vars.fontWeightMedium};
  margin-right: ${vars.spacingXs};
  display: inline-block;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 100%;
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #000;
    transform: scaleX(0);
    transform-origin: top left;
    transition: transform 0.3s ease;
  }
`;

export const NavbarSuperlink: React.FC<NavbarSuperLinkProps> = ({
  title,
  path,
  hasBackground,
  columnNumber,
}) => {
  const handleClick = e => {
    e.preventDefault();
    const currentUrl = window.location.pathname;
    const sanitisedLink = new URL(`${window.location.origin}${path}`);

    if (sanitisedLink.pathname.includes(currentUrl)) {
      window.location.href = path;
    } else {
      navigate(path);
    }
  };
  return (
    <StyledLink
      onClick={e => handleClick(e)}
      to={path}
      data-gtm-id={`${GTM_ID.FLYOVER_LINK_COLUMN}${columnNumber}`}
      hasBackground={hasBackground}
    >
      <Title className="superlink">{title}</Title>
      <IconWrapper>
        <ArrowRightIconAtom />
      </IconWrapper>
    </StyledLink>
  );
};
